export const SELECT_CATEGORY = "SELECT_CATEGORY";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const SET_MENU = "SET_MENU";
export const SET_LOADING = "SET_LOADING";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
export const SET_ON_LOAD_DIALOG = "SET_ON_LOAD_DIALOG";
export const SET_BACKGROUND_BLUR_ON_OPEN_FAB = "SET_BACKGROUND_BLUR_ON_OPEN_FAB";
export const SET_TINT = "SET_TINT";
export const SET_SUCCESS = "SET_SUCCESS";